// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"a13520b2","731":"df18356a"}[chunkId] + ".chunk.css";
};